import { searchV3 } from "../../../BaseRepositoryComponents";
import { buildAuthHeaders } from "../../../../utils/requestToolsV3";

const url = `${process.env.REACT_APP_URL_API_ERP_V3}/multitenant/origem-lead`;

export const mapToSelectOptions = (items = []) =>
  items.map((item) => ({
    value: item.id,
    label: item.descricao,
  }));

export const index = async ({ perPage = 100, page = 1, filter = {} } = {}) => {
  const path = new URL(url);
  path.searchParams.append("perPage", perPage);
  path.searchParams.append("page", page);

  Object.entries(filter).forEach(([name, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      path.searchParams.append(`filter[${name}]`, value);
    }
  });

  return searchV3(decodeURIComponent(path), "GET", buildAuthHeaders());
};

export const show = async (id) =>
  searchV3(`${url}/${id}`, "GET", buildAuthHeaders());

export const store = async (body) =>
  searchV3(url, "POST", buildAuthHeaders(), body);

export const update = async (id, body) =>
  searchV3(`${url}/${id}`, "PUT", buildAuthHeaders(), body);

export const fetchAllOptions = async () => {
  const response = await index({ perPage: 500, page: 1 });
  const items =
    response?.success && Array.isArray(response.data) ? response.data : [];
  return mapToSelectOptions(items);
};
